import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable()
export class LoaderService {
  loaders = [];
  isLoading = new Subject<boolean>();
  show(url: string) {
    this.loaders.push(url);
    this.isLoading.next(true);
  }
  hide() {
    this.loaders.pop();
    if (this.loaders.length === 0) {
      this.isLoading.next(false);
    }
  }
}
